export default __webpack_public_path__ + "static/media/about-grid-06.0f88c5dd.jpg";